import React from 'react'
import {useEffect} from 'react'
import {Grid, Typography, TextField} from '@material-ui/core'
import {
    DatePicker,
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers'
import {format} from 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import BackButton from '../Common/BackButton'

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import BootstrapInput from '../Common/BootstrapInput'
import {IRegisterRequestParams} from '../../interfaces/api'
import InputMask from "react-input-mask";
import SuhaGridItem from "../Suha/SuhaGridItem";
import NextButton from "../Common/NextButton";
import {makeStyles} from "@material-ui/core/styles";
import SuhaBubble from "../Suha/SuhaBubbleSmall";

const useStyles = makeStyles((theme) => ({
    customPicker: {
        // Target the header (month/year switcher)
        '& .MuiTypography-body1': {
            fontSize: 12, // Adjust header font size
        },
        '& .MuiPickersCalendarHeader-switchHeader': {
            fontSize: 12, // Example font size
        },
    },
    mt3: {
        marginTop: 40,
        marginBottom: 20,
    },
    root: {
        padding: '2vh 5vw',
        justifyContent:"center"
    },
}))
interface IUserInfoFormProps {
    handleSubmit: any
    userInfo: IRegisterRequestParams
    setUserInfo: (info: IRegisterRequestParams) => void
    handleNext: any
    handlePrev: any
    errors: any[]

    setErrors(values: any[]): void

    handleValidation(): void
}

export default function UserInfoForm(props: IUserInfoFormProps) {
    const classes = useStyles()
    useEffect(() => {
        const phone = document.getElementById('phone')
        const emergencyContactPhone = document.getElementById(
            'emergencyContactPhone'
        )
        if (phone !== null) {
            phone.addEventListener('keydown', enforceFormat)
            phone.addEventListener('keyup', formatToPhone)
        }
        if (emergencyContactPhone !== null) {
            emergencyContactPhone.addEventListener('keydown', enforceFormat)
            emergencyContactPhone.addEventListener('keyup', formatToPhone)
        }
    }, [])

    return (
        <React.Fragment>
            <form noValidate>
                <Grid container spacing={3} className={classes.root} direction={"row"} justifyContent={"center"}
                      alignItems={"flex-start"}>
                    <Grid  item xs={3} container direction={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                        <Grid item>
                            <BackButton show_button={true} handleClick={props.handlePrev}/>
                        </Grid>
                    </Grid>
                    <Grid item sm={7} xs={8}>
                        <SuhaBubble position={0}/>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <Typography gutterBottom>
                            Next, please share some information about you.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                            <BootstrapInput
                                placeholder="First Name *"
                                required
                                id="firstName"
                                name="firstName"
                                fullWidth
                                autoComplete="given-name"
                                value={props.userInfo.firstName}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        firstName: e.currentTarget.value,
                                    })
                                }/>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                            <BootstrapInput
                                placeholder="Last Name *"
                                required
                                id="lastName"
                                name="lastName"
                                fullWidth
                                value={props.userInfo.lastName}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        lastName: e.currentTarget.value,
                                    })
                                }/>
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                            <BootstrapInput
                                placeholder="Email *"
                                required
                                id="email"
                                name="email"
                                fullWidth
                                value={props.userInfo.email}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        email: e.currentTarget.value,
                                    })
                                }/>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                            <InputMask
                                mask="999-999-9999"
                                value={props.userInfo.phone}
                                disabled={false}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        phone: e.currentTarget.value,
                                    })
                                }
                            >
                                {() => <BootstrapInput
                                    placeholder="Cell Phone"
                                    required
                                    id="phone"
                                    name="phone"
                                    fullWidth
                                    type="tel"
                                />}
                            </InputMask>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                style={{marginTop:'-5px', marginBottom:'-5px'}}
                                InputProps={{
                                    style: {
                                        borderRadius: 4,
                                        position: 'relative',
                                        border: '1px solid #ced4da',
                                        fontSize: 16,
                                        width: '100%',
                                        padding: '1px 1px',
                                        height: 40
                                    },
                                }}
                                margin="normal"
                                inputVariant="outlined"
                                PopoverProps={{
                                    classes: { paper: classes.customPicker }
                                }}
                                disableToolbar
                                id="dob"
                                clearable
                                value={props.userInfo.dateOfBirth || null}
                                placeholder="Date of Birth"
                                format="MM/dd/yyyy"
                                onChange={(date: Date | null) => {
                                    if (date === null || !date) {
                                        return
                                    }
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        dateOfBirth: date.toLocaleDateString(),
                                    })
                                }}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                            <BootstrapInput
                                required
                                placeholder="Emergency Contact"
                                id="emergencyContact"
                                name="emergencyContact"
                                fullWidth
                                value={props.userInfo.emergencyContactName}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        emergencyContactName: e.currentTarget.value,
                                    })
                                }/>
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormControl fullWidth>
                            <InputMask
                                mask="999-999-9999"
                                value={props.userInfo.emergencyContactPhone}
                                disabled={false}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    props.setUserInfo({
                                        ...props.userInfo,
                                        emergencyContactPhone: e.currentTarget.value,
                                    })
                                }
                            >
                                {() => <BootstrapInput
                                    required
                                    placeholder="Emergency Contact Phone"
                                    id="emergencyContactPhone"
                                    name="emergencyContactPhone"
                                    fullWidth
                                    type="tel"
                                />}
                            </InputMask>
                        </FormControl>
                    </Grid>

                    <Grid item sm={7} xs={12}>
                        <NextButton handleClick={props.handleSubmit}/>
                    </Grid>
                </Grid>
            </form>
        </React.Fragment>
    )
}

//TODO move this to a shared lib

const isNumericInput = (event: any) => {
    const key = event.keyCode
    return (
        (key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) // Allow number pad
    )
}

const isModifierKey = (event: any) => {
    const key = event.keyCode
    return (
        event.shiftKey === true ||
        key === 35 ||
        key === 36 || // Allow Shift, Home, End
        key === 8 ||
        key === 9 ||
        key === 13 ||
        key === 46 || // Allow Backspace, Tab, Enter, Delete
        (key > 36 && key < 41) || // Allow left, up, right, down
        // Allow Ctrl/Command + A,C,V,X,Z
        ((event.ctrlKey === true || event.metaKey === true) &&
            (key === 65 || key === 67 || key === 86 || key === 88 || key === 90))
    )
}

const enforceFormat = (event: any) => {
    // Input must be of a valid number format or a modifier key, and not longer than ten digits
    if (!isNumericInput(event) && !isModifierKey(event)) {
        event.preventDefault()
    }
}

const formatToPhone = (event: any) => {
    if (isModifierKey(event)) {
        return
    }

    const input = event.target.value.replace(/\D/g, '').substring(0, 10) // First ten digits of input only
    const areaCode = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    if (input.length > 6) {
        event.target.value = `${areaCode}-${middle}-${last}`
    } else if (input.length > 3) {
        event.target.value = `${areaCode}-${middle}`
    } else if (input.length > 0) {
        event.target.value = `${areaCode}`
    }
}
